export default __webpack_public_path__ + "static/media/products_icon.bbc2575a.svg";